import React from 'react';
import { bool, func } from 'prop-types';
import { Button } from '@nike/nike-design-system-components';
import { Icon } from '../../components';

const DeleteButton = props => (
  <Button {...props}>
    <Icon name='trash' alt='Delete' />
  </Button>
);

DeleteButton.defaultProps = {
  disabled: false
};

DeleteButton.propTypes = {
  disabled: bool,
  onClick: func.isRequired
};

export default DeleteButton;
